import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import classnames from 'classnames';

import ActionRefreshContext from 'components/ActionRefreshContext';
import Header from 'components/Header';
import Tabs from 'components/Tabs';
import Sidebar from 'components/Sidebar';
import DeckRefreshContext from 'components/DeckRefreshContext';
import RefillOpportunityDeckModal from './RefillOpportunityDeckModal';
import RefreshActionsModal from './RefreshActionsModal';

import Config from 'configuration';

import AccessibleSidebar from 'components/AccessibleSidebar';
import Infobar from 'components/Infobar';
import Footer from 'components/Footer';
import LoadingScreen from 'components/LoadingScreen';
import News from 'components/News';

import MediaLgDown from 'components/Responsive/MediaLgDown';
// import MediaLgUp from 'components/Responsive/MediaLgUp';
import MediaMdUp from 'components/Responsive/MediaMdUp';
import MediaMdDown from 'components/Responsive/MediaMdDown';
import MediaSmDown from 'components/Responsive/MediaSmDown';
import MediaXlUp from 'components/Responsive/MediaXlUp';
import ResponsiveSidebar from 'components/Responsive/Sidebar';

import ResponsiveMenu from 'components/ResponsiveMenu';

import ReactCSSTransitionReplace from 'react-css-transition-replace';

import { NAV_ITEMS } from './constants';
import { openFatePurchase } from 'actions/storylet';
import { IStateAwareArea } from 'types/map';
import { IAppState } from 'types/app';

/**
 * This is a wrapper that contains the general app layout
 * The 'view' is passed in as a child
 */
class GeneralContainer extends React.Component<Props, State> {
  static displayName = 'GeneralContainer';

  navItems: { label: string, value: string }[];

  state = {
    isActionRefreshModalOpen: false,
    isDeckRefreshModalOpen: false,
  };


  constructor(props: Props) {
    super(props);
    this.navItems = [...NAV_ITEMS];
  }

  handleOpenActionRefreshModal = () => {
    this.setState({ isActionRefreshModalOpen: true });
  };

  handleOpenDeckRefreshModal = () => {
    this.setState({ isDeckRefreshModalOpen: true });
  };

  handleOpenPurchaseFateModal = () => {
    const { dispatch } = this.props;
    dispatch(openFatePurchase);
  };

  handleCloseActionRefreshModal = () => {
    this.setState({ isActionRefreshModalOpen: false });
  };

  handleCloseDeckRefreshModal = () => {
    this.setState({ isDeckRefreshModalOpen: false });
  };

  renderBanner = () => {
    const { currentArea } = this.props;
    const bgImage = `${Config.imageUrl}headers/${currentArea?.image}.png`;
    return (
      <div
        key={bgImage}
        className="banner banner--lg-up"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
    );
  };


  /**
   * Render
   * @return {[type]} [description]
   */
  render() {
    const {
      children,
      currentArea,
      fateData,
      history,
      sectionName,
    } = this.props;
    const { isActionRefreshModalOpen, isDeckRefreshModalOpen } = this.state;

    if (!fateData.fateCards.length) {
      return (
        <LoadingScreen />
      );
    }

    // To stop the safari clipping issue!
    // var primaryStyle = { zIndex: loading ? -1 : 1 };
    // I'm replacing this with a no-op until we can isolate the bug it fixes,
    // and fix it without disabling tabs during loading animations
    const primaryStyle = {};

    return (
      <ActionRefreshContext.Provider
        value={{
          onOpenActionRefreshModal: this.handleOpenActionRefreshModal,
          onOpenPurchaseFateModal: this.handleOpenPurchaseFateModal,
        }}
      >
        <DeckRefreshContext.Provider
          value={{ onOpenDeckRefreshModal: this.handleOpenDeckRefreshModal }}
        >
          <div>
            <a className="u-visually-hidden u-focusable" href="#main">Skip to main content</a>
            <AccessibleSidebar />
            <Header />

            <ReactCSSTransitionReplace
              transitionName="fade"
              transitionEnterTimeout={1000}
              transitionLeaveTimeout={1000}
            >
              {currentArea && this.renderBanner()}
            </ReactCSSTransitionReplace>

            <div>
              <MediaMdDown>
                <ResponsiveMenu />
              </MediaMdDown>
              <div className="content container">
                <div className="general-container__row">
                  <Sidebar />
                  <div className="col-primary" style={primaryStyle}>
                    <MediaMdUp>
                      <nav className="nav nav--tabs nav--tabs--main">
                        <Tabs
                          items={this.navItems}
                          active={history.location.pathname}
                        />
                      </nav>
                    </MediaMdUp>
                    <div
                      id="main"
                      className={classnames(
                        'tab-content tab-content--inverse inverse--bordered',
                        sectionName && sectionName,
                      )}
                      role="main"
                    >
                      <div className="tab-content__bordered-container">
                        {children}
                      </div>
                    </div>
                    <MediaMdUp>
                      <MediaLgDown>
                        <Footer />
                      </MediaLgDown>
                    </MediaMdUp>
                  </div>
                  <Infobar />
                </div>
              </div>
              <News />
              <MediaXlUp>
                <Footer />
              </MediaXlUp>
              <MediaSmDown>
                <Footer />
              </MediaSmDown>
            </div>
            <ResponsiveSidebar />
          </div>
          <RefillOpportunityDeckModal
            isOpen={isDeckRefreshModalOpen}
            onRequestClose={this.handleCloseDeckRefreshModal}
          />
          <RefreshActionsModal
            isOpen={isActionRefreshModalOpen}
            onRequestClose={this.handleCloseActionRefreshModal}
          />
        </DeckRefreshContext.Provider>
      </ActionRefreshContext.Provider>
    );
  }
}


interface Props extends RouteComponentProps {
  children?: React.ReactNode,
  currentArea?: IStateAwareArea,
  dispatch: Function,
  fateData: any,
  sectionName?: string,
}

interface State {
  isActionRefreshModalOpen: boolean,
  isDeckRefreshModalOpen: boolean,
}

const mapStateToProps = ({
  actions: { actionBankSize },
  fate: { data: fateData },
  map: { currentArea },
}: IAppState) => ({
  actionBankSize,
  fateData,
  currentArea,
});

export default withRouter(connect(mapStateToProps)(GeneralContainer));
